/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'per-room': {
    width: 24,
    height: 24,
    viewBox: '-14 -13 52 53',
    data: '<g><g stroke-width="1.65" _stroke="#000"><path pid="0" d="M3.5 12.5v11h17v-11" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/><path pid="1" d="M.5 12L12 1.5 23.5 12" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/><path pid="2" d="M16 2.5h3.5V6" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/per-room.js